/**
 * Convert duration part to seconds
 *
 * [hours] * (60 ^ 2)
 * [minutes] * (60 ^ 1)
 * [seconds] * (60 ^ 0)
 */
function durationPartToSeconds(partValue, partIndex, partsLength) {
  return parseInt(partValue, 10) * Math.pow(60, partsLength - partIndex - 1);
}

/**
 * Convert duration string to seconds number
 *
 * @see https://developers.google.com/search/docs/data-types/podcast#rss-feed-requirements
 *
 * Duration of the episode, could be in one of the following formats:
 * [hours]:[minutes]:[seconds]
 * [minutes]:[seconds]
 * [total_seconds]
 */
function episodeDurationToSeconds(rawDuration: string): number {
  if (!rawDuration || typeof rawDuration !== 'string') {
    return;
  }

  const parts = rawDuration.split(':');
  return parts.reduce(
    (totalSeconds, partValue, partIndex) =>
      totalSeconds + durationPartToSeconds(partValue, partIndex, parts.length),
    0,
  );
}

export default episodeDurationToSeconds;
